import Vue from 'vue'
import Component from 'vue-class-component'
import Statements from '../statement/Statements.vue'
import Convos from '../convo/Convos.vue'
import StatementSearch from '../search/StatementSearch.vue'
import ConvoSearch from '../search/ConvoSearch.vue'
import ProfileSection from '../profile/ProfileSection.vue'
import ConvoEdit from '../convo/ConvoEdit.vue'
import ConvoStatementEdit from '../convo/ConvoStatementEdit.vue'
import SelectEdit from './SelectEdit.vue'
import FeedSelect from './FeedSelect.vue'
import feedStore from '@/store/feed/feed-store'
import authStore from '@/store/auth/auth-store'
import ConvoCommentStatementEdit from '@/components/convo/ConvoCommentStatementEdit';
import ToggleButton from '@/components/buttons/ToggleButton';

@Component({
  name: 'feed',
  components: {
    'profile-section': ProfileSection,
    'statement-feed-section': Statements,
    'statement-edit-section': Statements,
    'convo-feed-section': Convos,
    'convo-edit-section': ConvoEdit,
    'convo-statement-edit-section': ConvoStatementEdit,
    'comment-statement-edit-section': ConvoCommentStatementEdit,
    'statement-feed-search': StatementSearch,
    'statement-edit-search': StatementSearch,
    'convo-feed-search': ConvoSearch,
    'convo-edit-search': StatementSearch,
    'convo-statement-edit-search': StatementSearch,
    'comment-statement-edit-search': StatementSearch,
    'statement-feed-form': SelectEdit,
    'statement-edit-form': SelectEdit,
    'convo-feed-form': SelectEdit,
    'convo-edit-form': SelectEdit,
    'convo-statement-edit-form': SelectEdit,
    'comment-statement-edit-form': SelectEdit,
    'feedSelect': FeedSelect,
    'toggle-button' : ToggleButton
  }
})
export default class Feed extends Vue {
  protected isSearchHidden = true;

  mounted (): void {
    console.log('Feed.ts: mounted')

    this.$store.subscribe((mutation, state) => {
      console.log('Feed mutation: type = %j', mutation.type)
      if (mutation.type === 'auth/setUser') {
        feedStore.dispatchInitFeed()
      }

      if (mutation.type === 'auth/setNotAuthenticated') {
        feedStore.dispatchInitFeed()
      }

      if (mutation.type === 'statement/copyStatement') {
        feedStore.dispatchNewStatement()
      }
      if (mutation.type === 'convo/copyConvo') {
        feedStore.dispatchNewConvo()
      }
      if (mutation.type === 'convo/editConvoStatements') {
        feedStore.dispatchEditConvoStatements()
      }
      if (mutation.type === 'convo/editCommentStatements') {
        feedStore.dispatchEditCommentStatements()
      }
    })

    if (authStore.isInitialized) {
      feedStore.dispatchInitFeed()
    }
  }

  get feedType () { return feedStore.state.feedType }
  get columns () { return feedStore.state.columns }
  get feedUser () { return feedStore.feedUser }
  get feedInitialized () { return feedStore.isInitialized }
  get feedComponent () { return feedStore.state.feedType + '-section' }
  get searchComponent () { return feedStore.state.feedType + '-search' }
  get formComponent () { return feedStore.state.feedType + '-form' }

  protected showSearch (): void {
    this.isSearchHidden = false;
  }

  protected hideSearch (): void {
    this.isSearchHidden = true;
  }
}
